;(function () {
  const modal = document.querySelector(".image-modal")
  const image = document.querySelector(".modal-bg")

  const frames = document.querySelectorAll(".timeline-box .image-frame")

  for (let i = 0; i < frames.length; i++) {
    frames[i].onclick = showModalOnClick
  }

  document.addEventListener("click", (e) => {
    // If user either clicks X button OR clicks outside the modal window, then close modal by calling closeModal()
    if (
      e.target.matches(".close-x") ||
      e.target.matches(".holder") ||
      e.target.matches(".image-modal")
    ) {
      closeModal()
    }
  })

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeModal()
    }
  })

  function showModalOnClick(e) {
    let src = e.srcElement.parentNode.children[0].style.backgroundImage
    src = src.substring(5, src.length - 2)
    modal.classList.add("active")
    image.src = src
  }

  function closeModal(e) {
    modal.classList.remove("active")
  }
})()
